import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

export const DisplayDeviceSlicer = createSlice({
  name: 'DisplayDevice',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<any[]>,
  reducers: {
    getDisplayDevice: (state, _) => {
      state.isLoading = true;
    },
    successGetDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearDisplayDeviceState: (state) => {
      state.data = {};
    },
  },
});

export const {
  getDisplayDevice,
  successGetDisplayDevice,
  failureGetDisplayDevice,
  clearDisplayDeviceState,
} = DisplayDeviceSlicer.actions;

export default DisplayDeviceSlicer.reducer;
